import {
  DeviceFeatureIconListLong,
  DeviceFeatureIconListShort,
  EcomAmexDiners,
  EcomCreditDebitCards,
  EcomOzow,
  EcomQRCodes,
  TapOnPhoneIconList,
} from '../assets/images';
import {
  BizWalletPro,
  InstantEFTOzow,
  QRScanToPay,
  VisaMasterCard,
  VodaPayChopChop,
  VodaPayKwika,
  VodaPayMax,
  VodaPayPaymentGateway,
  VodaPayTapOnPhone,
  VodaPayMax2,
  VodaPayPaymentRequest,
} from 'src/features/common/assets';
import { fileToBase64 } from '../helpers/file-to-base64';
import { Environment } from 'src/Environment';
import { EcomGatewayImage1, KwikaImage1, KwikaImage2, KwikaImage3, MaxImage1, MaxImage2, MaxImage3, PaymentRequestImage1, TapOnPhoneImage1, TapOnPhoneImage2 } from 'src/assets/images';

export const DEVICE_NAMES = {
  VODAPAY_CHOP_CHOP: 'VodaPay Chop-Chop',
  VODAPAY_ECOM_GATEWAY: 'VodaPay Payment Gateway',
  VODAPAY_KWIKA: 'VodaPay Kwika',
  VODAPAY_MAX: 'VodaPay Max',
  INSTANT_EFT: 'Instant EFT (Ozow)',
  QR_SCAN_TO_PAY: 'QR (Scan to Pay)',
  VISA_MASTERCARD: 'Visa/ Mastercard',
  AMERICAN_EXPRESS_DINERS: 'American Express/ Diners',
  BIZ_WALLET_PRO: 'Biz Wallet Pro',
  BIZ_PRO_WALLET: 'Business Pro Wallet',
  TAP_ON_PHONE: 'VodaPay Tap on Phone',
  MAX_2: 'VodaPay Max 2',
  VODAPAY_PAYMENT_REQUEST: 'VodaPay Payment Request',
};

export const VIRTUAL_DEVICES = [
  DEVICE_NAMES.VODAPAY_CHOP_CHOP,
  DEVICE_NAMES.VODAPAY_ECOM_GATEWAY,
  DEVICE_NAMES.TAP_ON_PHONE,
  DEVICE_NAMES.VODAPAY_PAYMENT_REQUEST,
  DEVICE_NAMES.BIZ_PRO_WALLET,
  DEVICE_NAMES.AMERICAN_EXPRESS_DINERS,
  DEVICE_NAMES.BIZ_WALLET_PRO,
  DEVICE_NAMES.INSTANT_EFT,
  DEVICE_NAMES.QR_SCAN_TO_PAY,
  DEVICE_NAMES.VISA_MASTERCARD,
];

export const PRODUCT_IMAGE_MAP = {
  [DEVICE_NAMES.VODAPAY_CHOP_CHOP]: VodaPayChopChop,
  [DEVICE_NAMES.VODAPAY_KWIKA]: VodaPayKwika,
  [DEVICE_NAMES.VODAPAY_MAX]: VodaPayMax,
  [DEVICE_NAMES.VODAPAY_ECOM_GATEWAY]: VodaPayPaymentGateway,
  [DEVICE_NAMES.INSTANT_EFT]: InstantEFTOzow,
  [DEVICE_NAMES.QR_SCAN_TO_PAY]: QRScanToPay,
  [DEVICE_NAMES.VISA_MASTERCARD]: VisaMasterCard,
  [DEVICE_NAMES.AMERICAN_EXPRESS_DINERS]: VisaMasterCard,
  [DEVICE_NAMES.BIZ_WALLET_PRO]: BizWalletPro,
  [DEVICE_NAMES.BIZ_PRO_WALLET]: BizWalletPro,
  [DEVICE_NAMES.TAP_ON_PHONE]: VodaPayTapOnPhone,
  [DEVICE_NAMES.MAX_2]: VodaPayMax2,
  [DEVICE_NAMES.VODAPAY_PAYMENT_REQUEST]: VodaPayPaymentRequest,
};

export const initializeProductImageMap = () => {
  const keys = Object.values(DEVICE_NAMES);

  keys.forEach(async (key) => {
    const cachedImage = localStorage.getItem(key);
    if (key !== DEVICE_NAMES.TAP_ON_PHONE && cachedImage && cachedImage.startsWith('data:image')) {
      PRODUCT_IMAGE_MAP[key] = cachedImage;
      return;
    }

    const base64Image = await fileToBase64(PRODUCT_IMAGE_MAP[key]);

    if (base64Image) {
      PRODUCT_IMAGE_MAP[key] = base64Image;
      localStorage.setItem(key, base64Image);
    }
  });
};

function getVodapayMaxDescription(isVasEnabled: boolean): string[] {
  const result = [
    'Dual SIM for super fast connectivity',
    'Accepts magnet, smart and contactless cards',
    'Unique merchant QR Codes for easy payments',
    'Free insurance included in rental fee',
    'Sell airtime, data and electricity',
    'EasyPay invoice payments and more',
    'Get and print reports, balances and statements',
  ];

  if (isVasEnabled) {
    const vasEnabledResult = [
      'Dual SIM for super fast connectivity',
      'Accepts magnet, smart and contactless cards',
      'Unique merchant QR Codes for easy payments',
      'Free insurance included in rental fee',
    ];
    return vasEnabledResult;
  }
  return result;
}

function getVodapayKwikaDescription(isVasEnabled: boolean): string[] {
  const result = [
    'Card payments made easy',
    'Free QR code payments',
    'Designed to take payments anywhere',
    'Simple user experience',
  ];

  if (isVasEnabled) {
    const vasEnabledResult = [
      'Card payments made easy',
      'Free QR code payments',
      'Designed to take payments anywhere',
      'Simple user experience',
    ];
    return vasEnabledResult;
  }
  return result;
}

export const PRODUCT_CATEGORY_NAME = 'E commerce Gateway';

export const PRODUCT_CATEGORY_NAME_MAP = {
  [DEVICE_NAMES.VODAPAY_ECOM_GATEWAY]: 'E commerce Gateway',
  [DEVICE_NAMES.VODAPAY_PAYMENT_REQUEST]: 'Payment Request',
};

export const PRODUCT_DETAILS_EXTRA = {
  [DEVICE_NAMES.VODAPAY_CHOP_CHOP]: {
    description: [
      'Dual SIM for super fast connectivity',
      'Accepts magnet, smart and contactless cards',
      'Unique merchant QR Codes for easy payments',
      'Free insurance included in rental fee',
    ],
    badge: { color: 'black', text: 'Free solution' },
    images: [],
    icons: [DeviceFeatureIconListShort],
  },
  [DEVICE_NAMES.VODAPAY_ECOM_GATEWAY]: {
    description: [
      'Only pay per transaction',
      'Easy integration options available',
      'Multiple Payment methods',
      'No setup or settlement cost',
    ],
    badge: { color: 'red', text: 'New' },
    images: [EcomGatewayImage1],
    icons: [DeviceFeatureIconListShort],
    deviceDescription: 'Take payments from your website in a few easy clicks',
  },
  [DEVICE_NAMES.VODAPAY_KWIKA]: {
    description: getVodapayKwikaDescription(
      Environment.current?.disabledFeatures?.valueAddedServices,
    ),
    badge: { color: 'red', text: 'Special offer' },
    images: [KwikaImage1, KwikaImage2, KwikaImage3],
    deviceDescription: 'The card machine for a business on the move',
    icons: [DeviceFeatureIconListLong],
  },
  [DEVICE_NAMES.VODAPAY_MAX]: {
    description: getVodapayMaxDescription(
      Environment.current?.disabledFeatures?.valueAddedServices,
    ),
    badge: { color: 'red', text: 'Red Hot Deals' },
    icons: [DeviceFeatureIconListLong],
    priceSubtitle: 'Was R600pm',
    images: [MaxImage1, MaxImage2, MaxImage3],
    deviceDescription: 'Do more with the Max card machine',
    tagText: 'Save R290',
  },
  [DEVICE_NAMES.TAP_ON_PHONE]: {
    description: [
      'No setup costs or minimum monthly fees',
      'Accept contactless payments on your phone',
      'Download the app and accept payments on on the spot',
      'Easy setup',
    ],
    badge: { color: 'black', text: 'New' },
    images: [TapOnPhoneImage1, TapOnPhoneImage2],
    icons: [TapOnPhoneIconList],
    deviceDescription: 'Turn your smartphone into a card machine with the free Tap on Phone app',
  },
  [DEVICE_NAMES.MAX_2]: {
    description: [],
    badge: { color: 'red', text: 'New' },
    images: [],
    icons: [DeviceFeatureIconListLong],
  },
  [DEVICE_NAMES.VODAPAY_PAYMENT_REQUEST]: {
    description: [
      'Safe and contactless QR payments',
      'Payments accepted via mobile apps',
      'No card details required',
      'Easy to setup',
    ],
    badge: { color: 'red', text: 'New' },
    images: [PaymentRequestImage1],
    icons: [DeviceFeatureIconListShort],
    deviceDescription: 'Get paid anywhere, anytime',
  },
  [DEVICE_NAMES.VISA_MASTERCARD]: {
    icons: [EcomCreditDebitCards],
  },
  [DEVICE_NAMES.AMERICAN_EXPRESS_DINERS]: {
    icons: [EcomAmexDiners],
  },
  [DEVICE_NAMES.INSTANT_EFT]: {
    icons: [EcomOzow],
  },
  [DEVICE_NAMES.QR_SCAN_TO_PAY]: {
    icons: [EcomQRCodes],
  },
};
